export default [
  {
    path: "/agenda/:id",
    name: "AgendaDetails",
    component: () => import("@/views/Page/Agenda/AgendaDetails.vue"),
    meta: {
      title: "AgendaDetails",
    },
  },
];